var map = {
	"./Adobe.svg": 1162,
	"./Atlassia.svg": 1163,
	"./Big.svg": 1164,
	"./Bugzilla.svg": 1165,
	"./Cpanel.svg": 1166,
	"./Customers/Etebar-gary.png": 1094,
	"./Customers/Etebar.png": 1095,
	"./Customers/Mapna-gray.png": 1096,
	"./Customers/Sina- gray.png": 1097,
	"./Customers/Sina.png": 1098,
	"./Customers/afam-color.png": 1099,
	"./Customers/afam-gray.png": 1100,
	"./Customers/banner-eseminar.webp": 1101,
	"./Customers/banner-helal.webp": 1102,
	"./Customers/banner-kale.webp": 1103,
	"./Customers/banner-mapna.webp": 1104,
	"./Customers/bime.webp": 1105,
	"./Customers/eseminar-d.webp": 1106,
	"./Customers/eseminar.webp": 1107,
	"./Customers/helal-d.webp": 1108,
	"./Customers/helal.webp": 1109,
	"./Customers/industry.webp": 1110,
	"./Customers/it.webp": 1111,
	"./Customers/kale-d.webp": 1112,
	"./Customers/kale.webp": 1113,
	"./Customers/mapna-color.png": 1114,
	"./Customers/mapna-d.webp": 1115,
	"./Customers/mapna.webp": 1116,
	"./Customers/software.webp": 1117,
	"./Direct.svg": 1167,
	"./Django.svg": 1168,
	"./Elsstic.svg": 1169,
	"./Jira.svg": 1170,
	"./MariaDB.svg": 1171,
	"./Maskgroup.svg": 1133,
	"./Microsoft.svg": 1172,
	"./MongoDB.svg": 1173,
	"./Moodle.svg": 1174,
	"./MySQL.svg": 1175,
	"./Neo4j.svg": 1176,
	"./Opencart.svg": 1177,
	"./Plone.svg": 1178,
	"./PostgreSQL.svg": 1179,
	"./R1.svg": 914,
	"./R2.svg": 915,
	"./R3.svg": 916,
	"./R4.svg": 917,
	"./REDMINE.svg": 1180,
	"./Rocket.svg": 1181,
	"./Step1-m.svg": 1182,
	"./Step1.svg": 1183,
	"./Step2-m.svg": 1184,
	"./Step2.svg": 1185,
	"./Step3.svg": 1186,
	"./Wordmark.svg": 1187,
	"./agility.svg": 1188,
	"./avatar.svg": 1189,
	"./avatar2.svg": 1190,
	"./avatar3.svg": 1191,
	"./avatar4.svg": 1192,
	"./avatar5.svg": 1193,
	"./cancle.svg": 1194,
	"./centralized.svg": 1195,
	"./configuration.svg": 1196,
	"./devops.svg": 1197,
	"./enterprise.svg": 1198,
	"./exclusive.svg": 1199,
	"./focus.svg": 1200,
	"./hardening.svg": 1201,
	"./header.svg": 880,
	"./hero.svg": 1147,
	"./iRedMail.svg": 1202,
	"./joomla.svg": 1203,
	"./laravel.svg": 1204,
	"./managed_service.png": 1205,
	"./managedservices_catalogue.png": 1206,
	"./monitor.svg": 1207,
	"./monitoring.svg": 1208,
	"./osCommerce.svg": 1209,
	"./prometheus.svg": 1210,
	"./redis.svg": 1211,
	"./section-header.svg": 959,
	"./technical.svg": 1212,
	"./tick.svg": 918,
	"./tick1.svg": 1213,
	"./woocommerce.svg": 1214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1292;